/**
 * @file オートコンプリートダイアログのヘッダ定義
 * @namespace ddv2.library
 */

/**
 * @module header
 */

/**
 * 取引先マスタのダイアログヘッダ
 */
const mstTorihikisakiHeaders = [
  { text: '取引先コード', value: 'torihikisakiCd' },
  { text: '得意先', value: 'tokuisakiFlgDisp', align: 'center' },
  { text: '仕入先', value: 'shiiresakiFlgDisp', align: 'center' },
  { text: '発注先', value: 'hacchusakiFlgDisp', align: 'center' },
  { text: '取引先名称', value: 'torihikisakiNm' },
  { text: '取引先名カナ', value: 'torihikisakiNmKana' },
  { text: '取引先正式名称', value: 'torihikisakiSeishikiNm' },
  { text: '取引先略称', value: 'torihikisakiAbbr' },
  // { text: '地域種別', value: 'chiikiSbtNm' },
  // { text: '地区種別', value: 'chikuSbtNm' },
  // { text: '取引先分類種別１', value: 'torihikisakiBunruiKbn1Nm' },
  // { text: '取引先分類種別２', value: 'torihikisakiBunruiKbn2Nm' },
  // { text: '取引先分類種別３', value: 'torihikisakiBunruiKbn3Nm' },
  { text: '適用開始日', value: 'tekiyoStartYmdDisp' },
  { text: '適用終了日', value: 'tekiyoEndYmdDisp' },
  { text: '表示順', value: 'hyojiOrder' }
]
/**
 * 車両マスタのダイアログヘッダ
 */
const mstSharyoHeaders = [
  // { text: '車両コード', value: 'sharyoCd' },
  { text: '自動車番号表示名', value: 'jidoshaHyojiNm' },
  { text: '所有区分', value: 'hacchusakiFlgKubun' },
  { text: '営業所コード', value: 'eigyoshoCd' },
  { text: '営業所名称', value: 'eigyoshoNm' },
  { text: '傭車先コード', value: 'hacchusakiCd' },
  { text: '傭車先名称', value: 'hacchusakiNm' },
  { text: '車両番号', value: 'sharyoNo' },
  { text: '登録地名', value: 'torokuChimei' },
  { text: '登録分類番号', value: 'torokuBunruiNo' },
  { text: '登録平仮名', value: 'torokuHiragana' },
  { text: '登録一連指定番号', value: 'torokuIchirenShiteiNo' },
  { text: '車種種別', value: 'shashuSbtNm' },
  { text: '運賃車種種別', value: 'unchinShashuSbtNm' },
  /*
  { text: '車両グループ種別１', value: 'sharyoGroupSbt1Nm' },
  { text: '車両グループ種別２', value: 'sharyoGroupSbt2Nm' },
  { text: '車両グループ種別３', value: 'sharyoGroupSbt3Nm' },
  { text: '車両グループ種別４', value: 'sharyoGroupSbt4Nm' },
  { text: '車両グループ種別５', value: 'sharyoGroupSbt5Nm' },
  { text: '廃車年月日', value: 'haishaYmd' },
  { text: '積載量', value: 'saidaisekisaiRyo' },
  { text: '燃費', value: 'nenpi' },
  { text: '購入年月日', value: 'konyuYmd' },
  { text: '購入価格', value: 'konyuKakaku' },
  { text: '登録手数料', value: 'torokuTesuryo' },
  { text: '自動車税金額', value: 'jidoshaZeiKingaku' },
  { text: '重量税金額', value: 'juryoZei' },
  { text: '取得税金額', value: 'shutokuZeiKingaku' },
  { text: '自賠責保険金額', value: 'jibaisekiHokenKingaku' },
  { text: '車両保険金額', value: 'sharyoHokenKingaku' },
  { text: '対人保険金額', value: 'taijinHokenKingaku' },
  { text: '対物保険金額', value: 'taibutsuHokenKingaku' },
  { text: '貨物保険金額', value: 'kamotsuHokenKingaku' },
  */
  { text: '適用開始日', value: 'tekiyoStartYmdDisp' },
  { text: '適用終了日', value: 'tekiyoEndYmdDisp' },
  { text: '表示順', value: 'hyojiOrder' }
]
/**
 * 品名マスタのダイアログヘッダ
 */
const mstHinmeiHeaders = [
  { text: '品名コード', value: 'hinmeiCd' },
  { text: '品名', value: 'hinmeiNm' },
  { text: '品名カナ', value: 'hinmeiNmKana' },
  { text: '得意先コード', value: 'torihikisakiCd' },
  { text: '得意先名称', value: 'torihikisakiNm' },
  { text: '単価', value: 'tanka' },
  { text: '単位区分', value: 'unitKbnNm' },
  { text: '重量', value: 'hinJuuryo' },
  { text: 'ロット', value: 'hinLot' },
  { text: '入数', value: 'hinIrisu' },
  { text: '荷姿', value: 'hinNisugata' },
  { text: '適用開始日', value: 'tekiyoStartYmdDisp' },
  { text: '適用終了日', value: 'tekiyoEndYmdDisp' },
  { text: '表示順', value: 'hyojiOrder' }
]
/**
 * 発着地マスタのダイアログヘッダ
 */
const mstHacchakuchiHeaders = [
  { text: '発着地コード', value: 'hacchakuchiCd' },
  { text: '発着地名称', value: 'hacchakuchiNm' },
  { text: '発着地名称カナ', value: 'hacchakuchiNmKana' },
  { text: '発着地グループコード', value: 'hacchakuchiGroupCd' },
  { text: '取引先コード', value: 'torihikisakiCd' },
  { text: '取引先名称', value: 'torihikisakiNm' },
  { text: '取引先担当者', value: 'torihikisakiTantosha' },
  { text: '郵便番号', value: 'yubinNo' },
  { text: '住所', value: 'jusho' },
  { text: '電話番号', value: 'telNo' },
  { text: '適用開始年月日', value: 'tekiyoStartYmdDisp' },
  { text: '適用終了年月日', value: 'tekiyoEndYmdDisp' },
  { text: '表示順', value: 'hyojiOrder' }
]
/**
 * 営業所マスタのダイアログヘッダ
 */
const mstEigyoshoHeaders = [
  { text: '営業所コード', value: 'eigyoshoCd' },
  { text: '営業所名称', value: 'eigyoshoNm' },
  { text: '営業所正式名称', value: 'eigyoshoSeishikiNm' },
  // { text: '発注先コード', value: 'hacchusakiCd' },
  // { text: '発注先名称', value: 'hacchusakiNm' },
  // { text: '運輸局区分', value: 'unyuKbnNm' },
  // { text: '地域種別', value: 'chiikiSbtNm' },
  // { text: '地区種別', value: 'chikuSbtNm' },
  { text: '郵便番号', value: 'yubinNo' },
  { text: '住所１', value: 'jusho1' },
  { text: '住所２', value: 'jusho2' },
  // { text: '住所３', value: 'jusho3' },
  { text: '電話番号', value: 'telNo' },
  { text: 'FAX番号', value: 'faxNo' },
  // { text: '請求書会社名称', value: 'seikyushoKaishaNm' },
  // { text: '請求書郵便番号', value: 'seikyushoYubinNo' },
  // { text: '請求書住所１', value: 'seikyushoJusho1' },
  // { text: '請求書住所２', value: 'seikyushoJusho2' },
  // { text: '請求書住所３', value: 'seikyushoJusho3' },
  // { text: '請求書電話番号', value: 'seikyushoTelNo' },
  // { text: '請求書FAX番号', value: 'seikyushoFaxNo' },
  { text: '適用開始日', value: 'tekiyoStartYmdDisp' },
  { text: '適用終了日', value: 'tekiyoEndYmdDisp' },
  { text: '表示順', value: 'hyojiOrder' }
]
/**
 * 人員マスタのダイアログヘッダ
 */
const mstJininHeaders = [
  { text: '人員コード', value: 'jininCd' },
  { text: '人員氏名', value: 'jininNmSei' },
  { text: '人員氏名カナ', value: 'jininNmKanaSei' },
  { text: '営業所コード', value: 'eigyoshoCd' },
  { text: '営業所名称', value: 'eigyoshoNm' },
  { text: '乗務員', value: 'jomuFlgDisp', align: 'center' },
  { text: '人員略称', value: 'jininAbbr' },
  { text: '性別', value: 'seibetsuKbnNm' },
  { text: '血液型', value: 'ketsuekigataKbnNm' },
  { text: '生年月日', value: 'seinengappi' },
  { text: '郵便番号', value: 'yubinNo' },
  { text: '住所１', value: 'jusho1' },
  { text: '住所２', value: 'jusho2' },
  { text: '住所３', value: 'jusho3' },
  { text: '電話番号', value: 'telNo' },
  { text: '携帯番号', value: 'keitaiTelNo' },
  { text: 'メールアドレス', value: 'mailAddress' },
  { text: '職種', value: 'shokushuSbtNm' },
  { text: '適用開始日', value: 'tekiyoStartYmdDisp' },
  { text: '適用終了日', value: 'tekiyoEndYmdDisp' },
  { text: '表示順', value: 'hyojiOrder' }
]
/**
 * 自社銀行口座マスタのダイアログヘッダ
 */
const mstJishaGinkoKouzaHeaders = [
  { text: '金融機関コード', value: 'kinyuKikanCd' },
  { text: '金融機関名', value: 'kinyuKikanNm' },
  { text: '支店コード', value: 'kinyuKikanShitenCd' },
  { text: '支店名', value: 'kinyuKikanShitenNm' },
  { text: '口座種別', value: 'kozaSbt' },
  { text: '口座番号', value: 'kozaNo' },
  { text: '口座名義', value: 'kozaMeigiNm' },
  { text: '外部連携用テキスト', value: 'gaibuRenkeiyoText' },
  { text: '銀行口座情報備考', value: 'ginkoKozaJohoBiko' },
  { text: '表示順', value: 'hyojiOrder' }
]
/**
 * 権限グループマスタのダイアログヘッダ
 */
const mstKengenGroupHeaders = [
  { text: '権限グループコード', value: 'kengenGroupCd' },
  { text: '権限グループ名称', value: 'kengenGroupNm' },
  { text: '表示順', value: 'hyojiOrder' }
]

/**
 * 区分種別種類マスタのダイアログヘッダ
 */
const msysKubunShubetsuShurui = [
  { text: '区分種別種類コード', value: 'kbnSbtShuruiCd' },
  { text: '区分種別種類名称', value: 'kbnSbtShuruiNm' },
  { text: '表示順', value: 'hyojiOrder' }
]

/**
 * 区分マスタのダイアログヘッダ
 */
const msysKubunHeaders = [
  { text: '区分種類コード', value: 'kbnShuruiCd' },
  { text: '区分コード', value: 'code' },
  { text: '区分コード名', value: 'codeNm' },
  { text: '区分コード正式名', value: 'codeSeishikiNm' },
  { text: '表示順', value: 'hyojiOrder' }
]

/**
 * 種別マスタのダイアログヘッダ
 */
const mstShubetsuHeaders = [
  { text: '種別種類コード', value: 'sbtShuruiCd' },
  { text: '種別コード', value: 'sbtCd' },
  { text: '種別コード名', value: 'sbtNm' },
  { text: '表示順', value: 'hyojiOrder' }
]

/**
 * 車両マスタViewのダイアログヘッダ
 */
const vwCMstSharyoHeaders = [
  // { text: '車両コード', value: 'sharyoCd' },
  { text: '車両表示名', value: 'jidoshaHyojiNm' },
  { text: '所有区分', value: 'hacchusakiFlgKubun' },
  { text: '営業所', value: 'eigyoshoNm' },
  { text: '発注先', value: 'hacchusakiNm' },
  { text: '車両番号', value: 'sharyoNo' },
  { text: '自動車登録番号', value: 'torokuNo' },
  { text: '車種種別', value: 'shashuSbtNm' },
  /*
  { text: '車両グループ種別１', value: 'sharyoGroupSbt1Nm' },
  { text: '車両グループ種別２', value: 'sharyoGroupSbt2Nm' },
  { text: '車両グループ種別３', value: 'sharyoGroupSbt3Nm' },
  { text: '車両グループ種別４', value: 'sharyoGroupSbt4Nm' },
  { text: '車両グループ種別５', value: 'sharyoGroupSbt5Nm' },
  { text: '運賃車種種別', value: 'unchinShashuSbtNm' },
  { text: '廃車年月日', value: 'haishaYmdDisp', align: 'center' },
  { text: '積載量', value: 'saidaisekisaiRyoDisp', align: 'end' },
  { text: '燃費', value: 'nenpiDisp', align: 'end' },
  { text: '購入年月日', value: 'konyuYmdDisp', align: 'center' },
  { text: '購入価格', value: 'konyuKakakuDisp', align: 'end' },
  { text: '登録手数料', value: 'torokuTesuryoDisp', align: 'end' },
  { text: '予定使用年数', value: 'yoteiShiyoNensuDisp', align: 'end' },
  { text: '自動車税金額', value: 'jidoshaZeiKingakuDisp', align: 'end' },
  { text: '重量税金額', value: 'juryoZeiDisp', align: 'end' },
  { text: '取得税金額', value: 'shutokuZeiKingakuDisp', align: 'end' },
  { text: '自賠責保険金額', value: 'jibaisekiHokenKingakuDisp', align: 'end' },
  { text: '車両保険金額', value: 'sharyoHokenKingakuDisp', align: 'end' },
  { text: '対人保険金額', value: 'taijinHokenKingakuDisp', align: 'end' },
  { text: '対物保険金額', value: 'taibutsuHokenKingakuDisp', align: 'end' },
  { text: '貨物保険金額', value: 'kamotsuHokenKingakuDisp', align: 'end' },
  */
  { text: '適用開始年月日', value: 'tekiyoStartYmdDisp', align: 'center' },
  { text: '適用終了年月日', value: 'tekiyoEndYmdDisp', align: 'center' },
  { text: '表示順', value: 'hyojiOrderDisp', align: 'end' }
]

/**
 * 地区マスタのダイアログヘッダ
 */
const mstShuhaiChikuHeaders = [
  { text: '集配地区コード', value: 'shuhaiChikuCd' },
  { text: '集配地区名称', value: 'shuhaiChikuNm' },
  { text: '集配地域名称', value: 'shuhaiChiikiNm' },
  { text: '適用開始日', value: 'tekiyoStartYmdDisp' },
  { text: '適用終了日', value: 'tekiyoEndYmdDisp' },
  { text: '表示順', value: 'hyojiOrder' }
]

/**
 * 地区マスタのダイアログヘッダ
 */
const mstBumonHeaders = [
  { text: '部門コード', value: 'bumonCd' },
  { text: '部門名称', value: 'bumonNm' },
  { text: '部門略称', value: 'bumonAbbr' },
  { text: '適用開始日', value: 'tekiyoStartYmdDisp' },
  { text: '適用終了日', value: 'tekiyoEndYmdDisp' },
  { text: '表示順', value: 'hyojiOrder' }
]

/**
 * 地名マスタのダイアログヘッダ
 */
const vwCMstChimeiHeaders = [
  { text: '地名コード', value: 'chimeiCd' },
  { text: '県コード', value: 'todofukenCd' },
  { text: '県名', value: 'todofukenNm' },
  { text: '地域コード', value: 'chiikiCd' },
  { text: '地域名', value: 'chiikiNm' },
  { text: '地域区分コード', value: 'chiikiKbnCd' },
  { text: '地域区分名', value: 'chiikiKbnNm' },
  { text: '空港コード', value: 'kukoCd' },
  { text: '空港名', value: 'kukoNm' },
  { text: '航空会社コード', value: 'kokuKaishaCd' },
  { text: '航空会社名', value: 'kokuKaishaNm' },
  { text: '地区コード', value: 'shuhaiChikuCd' },
  { text: '地区名', value: 'shuhaiChikuNm' },
  { text: '適用開始年月日', value: 'tekiyoStartYmdDisp' },
  { text: '適用終了年月日', value: 'tekiyoEndYmdDisp' },
  { text: '表示順', value: 'hyojiOrder' }
]

/**
 * 燃費カテゴリマスタのダイアログヘッダ
 */
const mstNenpiCategoryHeaders = [
  { text: 'カテゴリコード', value: 'nenpiCategoryCd' },
  { text: 'カテゴリ名称', value: 'nenpiCategoryNm' },
  { text: '表示順', value: 'hyojiOrder' }
]

export default {
  mstTorihikisakiHeaders,
  mstSharyoHeaders,
  mstHinmeiHeaders,
  mstHacchakuchiHeaders,
  mstEigyoshoHeaders,
  mstJininHeaders,
  mstJishaGinkoKouzaHeaders,
  mstKengenGroupHeaders,
  msysKubunShubetsuShurui,
  msysKubunHeaders,
  mstShubetsuHeaders,
  vwCMstSharyoHeaders,
  mstShuhaiChikuHeaders,
  mstBumonHeaders,
  vwCMstChimeiHeaders,
  mstNenpiCategoryHeaders
}
